import { call, put } from 'redux-saga/effects';

import { requestFailed } from '../../bootstrap/redux/actions/RequestFailedAction';
import { Messages } from '../../codegen/Localize';
import { CreateFlowSubscriptionReduxAction } from '../actions/CreateFlowSubscriptionReduxAction';
import { showCreateFlowSubscriptionDialog } from '../components/FlowSubscriptionCreationDialog';

export function* handleCreateFlowSubscription(action: CreateFlowSubscriptionReduxAction) {
  try {
    const flow = action.flow;
    yield call(showCreateFlowSubscriptionDialog, flow.id, flow.name);
  } catch (e) {
    yield put(requestFailed(e, Messages.unexpectedError()));
  }
}
